var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
import { useModalContext } from '../context';
/**
 * # Modal.Body
 *
 * 모달의 바디 영역입니다.
 *
 * @example ```tsx
 * <Modal.Body>This is a modal</Modal.Body>
 * ```
 */
var Body = function (props) {
    var children = useModalContext(props).children;
    return <Wrapper>{children}</Wrapper>;
};
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 1.5rem;\n  font-size: 0.875rem;\n  line-height: 1.6;\n"], ["\n  padding: 1.5rem;\n  font-size: 0.875rem;\n  line-height: 1.6;\n"])));
export { Body };
var templateObject_1;
//# sourceMappingURL=Body.jsx.map